import { render } from "./NetworkError.vue?vue&type=template&id=2d41e9f9"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__